import React from "react";
import { Link } from "react-router-dom";
import { BusinessHeader, BusinessFooter } from "./BusinessHome";

const PLANS = [
  { name: "Trial", price: "Free", period: "14 days", cta: "Start Trial", features: ["All features", "1 outlet", "Up to 20 tables", "Email support"] },
  { name: "Basic", price: "₹999", period: "/ month", cta: "Book Demo", features: ["1 outlet", "Unlimited tables", "All customer features", "Priority support"], highlight: false },
  { name: "Pro", price: "₹1,999", period: "/ month", cta: "Book Demo", features: ["Everything in Basic", "Video menu + analytics", "Custom page tabs", "Offers engine"], highlight: true },
  { name: "Enterprise", price: "Talk to us", period: "", cta: "Contact Sales", features: ["Multi-outlet", "Custom onboarding", "Dedicated success manager", "SLA"] },
];

export default function BusinessPricing() {
  return (
    <div className="min-h-screen">
      <BusinessHeader />
      <div className="max-w-6xl mx-auto px-4 py-10">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-brand-dark">Simple plans.</h1>
        <p className="text-brand-dark/60 mt-2">Pay monthly, cancel anytime. Enterprise? Let's chat.</p>

        <div className="grid md:grid-cols-4 gap-4 mt-6">
          {PLANS.map((p) => (
            <div
              key={p.name}
              className={`rounded-2xl p-5 border ${p.highlight ? "bg-brand-dark text-brand-light border-brand-dark" : "bg-white border-brand-dark/10"}`}
              data-testid={`plan-${p.name}`}
            >
              <div className="font-heading text-xl font-bold">{p.name}</div>
              <div className="mt-3 font-heading text-3xl font-bold">
                {p.price} <span className="text-sm opacity-70">{p.period}</span>
              </div>
              <ul className={`mt-4 text-sm space-y-1 ${p.highlight ? "text-brand-light/80" : "text-brand-dark/70"}`}>
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2">
                    <span className={p.highlight ? "text-brand-orange" : "text-brand-orange"}>✓</span>{f}
                  </li>
                ))}
              </ul>
              <Link
                to={p.name === "Enterprise" ? "/business/contact" : "/business/demo"}
                className={`mt-6 inline-block w-full text-center px-4 py-2 rounded-full font-medium ${p.highlight ? "bg-brand-orange text-white" : "bg-brand-dark text-brand-light"}`}
              >
                {p.cta}
              </Link>
            </div>
          ))}
        </div>

        <div className="mt-10 max-w-2xl">
          <h2 className="font-heading text-2xl font-bold text-brand-dark">FAQ</h2>
          <div className="mt-3 space-y-2 text-sm">
            {[
              ["How fast can we start?", "Same day. We onboard your menu, set up your Page Tabs, and issue QR codes within hours."],
              ["What about NFC tags?", "We supply them at cost. Or start with QR — the platform works identically."],
              ["Cancellation policy?", "Cancel anytime. Your data stays yours."],
              ["Do you take a % of orders?", "No. Flat subscription only. Every rupee stays with you."],
            ].map(([q, a]) => (
              <details key={q} className="bg-white rounded-xl border border-brand-dark/5 p-4">
                <summary className="font-medium text-brand-dark cursor-pointer">{q}</summary>
                <div className="text-brand-dark/70 mt-1">{a}</div>
              </details>
            ))}
          </div>
        </div>
      </div>
      <BusinessFooter />
    </div>
  );
}
